const { Text } = require("@chakra-ui/react");

const InvoiceBankDetails = ({bankDetails}) => {
  return (
    <div>
      <Text className="fw-600">Bank Account Information:</Text>
      <div className="new-bank-details-container">
        <Text className="terms-text">Bank Name</Text>:
        <Text className="terms-text">{bankDetails?.bankName}</Text>
        <Text className="terms-text">Branch Name</Text>:
        <Text className="terms-text">{bankDetails?.branchName}</Text>
        <Text className="terms-text">Account Number</Text>:
        <Text className="terms-text">{bankDetails?.accountNumber}</Text>
        <Text className="terms-text">IFSC</Text>:
        <Text className="terms-text">{bankDetails?.ifsc}</Text>
        <Text className="terms-text">SWIFT</Text>:
        <Text className="terms-text">{bankDetails?.swift}</Text>
      </div>
    </div>
  );
};

export default InvoiceBankDetails;
